import { Main } from './components';

const Mismatches = () => <Main />;

export default Mismatches;

